/**
 * I giocatori di un'agenzia, con il loro saldo.
 *
 * Serve alla tendina della schedina: solo i giocatori possono giocare, quindi
 * l'agenzia compila per uno di loro e la scommessa resta intestata a lui.
 *
 * Due rotte, due servizi, una chiamata ciascuno: i figli diretti dalla rete e
 * i saldi dal credito, chiesti tutti insieme invece che uno per uno.
 */

function indirizzoGateway() {
  const env = (typeof window !== 'undefined' && window.env) ? window.env : {};
  return env.REACT_APP_API_URL || 'http://localhost:9001';
}

function intestazioni() {
  const token = typeof window !== 'undefined'
    ? window.localStorage.getItem('access_token') : null;
  const h = {'Content-Type': 'application/json'};
  if (token) h.Authorization = `Bearer ${token}`;
  const tenant = typeof window !== 'undefined'
    && window.env && window.env.REACT_APP_API_TENANT;
  if (tenant) h.TENANT_ID = tenant;
  h['X-Client-Surface'] = 'FRONTEND';
  return h;
}

const GIOCATORE = ['PLAYER', 'WEB_USER'];

/**
 * @returns {Promise<Array<{userId, username, saldo}>>} i figli diretti che
 *          sono giocatori, col saldo DISPONIBILE. Elenco vuoto se non si
 *          riesce a leggerli: la tendina resta vuota e il pulsante spento,
 *          che e' meglio di una tendina con dentro numeri sbagliati.
 */
export async function giocatoriDi(agenzia) {
  if (!agenzia) return [];

  const base = indirizzoGateway();

  let figli = [];
  try {
    /* LA ROTTA DEVE PASSARE DAL GATEWAY, non basta che esista nel servizio.
       Prima si chiamava /jurisdiction/children/id/{id}: nel
       jurisdiction-service c'e' davvero, ma il gateway instrada solo
       /admin/types, /admin/jurisdiction e /private/jurisdiction. Ogni
       chiamata moriva li' con un 404 e la tendina restava vuota per sempre --
       cioe' un'agenzia non poteva mai scegliere un suo giocatore.
       Adesso la rotta sta dove il gateway la vede, e chiede i FIGLI DIRETTI:
       il sottoalbero di un'azienda ha ventimila nodi e questa e' una tendina
       da dodici. */
    const risposta = await fetch(
        `${base}/private/jurisdiction/${encodeURIComponent(agenzia)}/children`,
        {headers: intestazioni()});
    if (!risposta.ok) {
      console.warn('[giocatori] rete non leggibile:', risposta.status);
      return [];
    }
    const dati = await risposta.json();
    figli = Array.isArray(dati) ? dati : (dati.children || dati.users || []);
  } catch (e) {
    console.warn('[giocatori] rete non raggiungibile:', e);
    return [];
  }

  const giocatori = figli.filter((u) => {
    const tipo = String(u.type || u.role || '').toUpperCase().replace(/-/g, '_');
    return GIOCATORE.indexOf(tipo) !== -1;
  });

  if (giocatori.length === 0) return [];

  const saldi = await saldiDi(giocatori.map((g) => g.userId || g.id));

  return giocatori.map((g) => {
    const id = g.userId || g.id;
    return {
      userId: id,
      /* USERNAME, mai nome e cognome: vale ovunque si mostri un utente. */
      username: g.name || g.username || id,
      saldo: saldi[id] === undefined ? null : saldi[id],
    };
  });
}

/**
 * I saldi disponibili, tutti in una chiamata sola.
 *
 * Il campo e' `available` -- quanto la posizione puo' ancora impegnare --
 * non `userBalance`, che e' il denaro che ha in mano senza contare il fido.
 * Per una giocata conta il primo.
 */
async function saldiDi(identificativi) {
  try {
    const risposta = await fetch(`${indirizzoGateway()}/private/credit/figures`, {
      method: 'POST',
      headers: intestazioni(),
      body: JSON.stringify(identificativi),
    });
    if (!risposta.ok) {
      console.warn('[giocatori] saldi non leggibili:', risposta.status);
      return {};
    }
    const elenco = await risposta.json();
    const saldi = {};
    (elenco || []).forEach((f) => {
      if (f && f.userId) {
        saldi[f.userId] = f.available !== undefined ? f.available : f.userBalance;
      }
    });
    return saldi;
  } catch (e) {
    console.warn('[giocatori] saldi non raggiungibili:', e);
    return {};
  }
}
